import React from "react";
import { Building2 } from "lucide-react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import PageContainer from "../components/layout/PageContainer";
import OrganizationContextForm from "../components/organization/OrganizationContextForm";

const OrganizationContext = () => {
    const location = useLocation();
    const { data } = useSelector((state) => state.organizationContext);
    const shouldFocusFirstField = Boolean(location.state?.focusFirstField);

    return (
        <main className="min-h-screen bg-[#F8F8FE]">
            <PageContainer className="py-6 sm:py-8">
                <div className="mx-auto max-w-5xl">
                    <header className="mb-6 flex items-start gap-4">
                        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 ring-1 ring-indigo-100">
                            <Building2 size={24} aria-hidden="true" />
                        </div>
                        <div className="min-w-0">
                            <h1 className="text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl">
                                Organization Context
                            </h1>
                            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-600 sm:text-base">
                                Keep your company context ready for lead search.
                            </p>
                        </div>
                    </header>

                    <OrganizationContextForm
                        initialData={data}
                        autoFocusFirstField={shouldFocusFirstField}
                    />
                </div>
            </PageContainer>
        </main>
    );
};

export default OrganizationContext;
